import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  EUROCOUPONS_ISSUE(state, euroCouponsIssue) {
    state.cached = euroCouponsIssue
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchEuroCouponsIssue(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/issues/${payload.query}`, payload.type).then((response) => {
      if (payload.type) {
        return response
      }
      const request = response.data
      context.commit('EUROCOUPONS_ISSUE', request)
      return request
      
      
    })
  },

  fetchEuroCouponsIssueOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/issues/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroCouponsIssueDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateEuroCouponsIssue(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/euro_coupons/issues/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteEuroCouponsIssue(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}